import { ViewChild } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatOption } from '@angular/material/core';

@Component({
    selector: 'app-search-dropdown',
    templateUrl: 'search-dropdown.component.html',
    styleUrls: ['search-dropdown.component.scss'],
})
export class SearchDropdownComponent implements OnInit {
    _enabled: boolean = true;
    
    @Input()
    set enabled(value: boolean) {
        value && this.control?.enable({ emitEvent: false });
        !value && this.control?.disable({ emitEvent: false });
    }
    get eanbled() {
        return this._enabled;
    }

    @Input() label: string = '';
    @Input() isMultiple: boolean = false;
    @Input() optionsArray: any[] = [];
    @Input() control: FormControl = new FormControl();
    @Input() key: string = '';
    @Input() panelClass: string = '';
    @ViewChild('allSelected') private allSelected: MatOption | undefined;

    filter: string = '';
    optionsMirror: any[] = [];

    constructor() {}

    ngOnInit(): void {
        this.optionsMirror = this.optionsArray;
    }

    hasValue() {
        const value = this.control.value;

        if (value instanceof Array) return value.length > 0;

        return !!value;
    }

    compareFilterObjects(object1: any, object2: any) {
        return object1 && object2 && object1.descricao === object2.descricao;
    }

    getFormatedValue() {
        const selected = this.control.value;

        if (this.isMultiple && selected instanceof Array) {
            const length = selected.length;
            const [value] = selected;

            if (length === 1) return this.getOptionValue(value);
            if (this.allSelected?.selected) return 'ALL';

            if (length > 1) {
                return `${this.getOptionValue(value)} (+${length -1})`;
            }
        }

        return this.getOptionValue(selected);
    }

    getOptionValue(option: any) {
        if (!option) return null;
        return this.key ? option[this.key] : option;
    }

    toggleAllSelection() {
        if (this.allSelected?.selected) {
            this.control.patchValue(this.optionsArray);
            this.allSelected.select();
        } else {
            this.control.patchValue([]);
            this.allSelected?.deselect();
        }
    }

    toggleAllSelectionIfIsMultiple() {
        if (this.isMultiple) {
            var selectedElements = this.control.value.filter((x: any) => x.id).length;

            if (selectedElements >= this.optionsArray.length) {
                this.allSelected?.select();
            } else {
                this.allSelected?.deselect();
            }
        }
    }

    search(query: string) {
        this.filter = query;
        if (query.length > 0) {
            this.optionsArray = this.optionsMirror.filter((value: any) =>
                this.getOptionValue(value)
                    .toString()
                    .toLowerCase()
                    .includes(query.toLowerCase())
            );  
        } else {
            this.optionsArray = this.optionsMirror;
            this.control.patchValue([]);
            this.allSelected?.deselect();
        }
    }
}